<template>
  <section class="section photo_gallery section_responsive bg-gray-lighter" id="galerija">
      <div class="box-spacer">
        <p class="heading-1">GALERIJA</p><br/>
      </div>
        <div class="shell-condensed">
          <div class="range range-condensed" data-lightgallery="group">
            <div v-for="(image, index) in images" :key="index" class="cell-sm-6 cell-md-4 cell-lg-3 image-item" v-bind:class="[image.isActive ? 'fade-in' : 'fade-in']">
                <a class="thumb-ruby thumb-mixed_height-4" @click="showModalWindow(index)" data-lightgallery="group-item">
                  <img class="thumb-ruby__image" :src="getSrcLink(index)" :alt="image" width="400" height="363">
                  <div class="thumb-ruby__caption"> 
                    <!-- <p class="thumb-ruby__title heading-3">Image #1</p>
                    <p class="thumb-ruby__text">If you are looking for high quality wedding photography, I will be glad to help you.</p> -->
                  </div>
                </a>
            </div>
          </div>
        </div>

        <div class="box-spacer post-single">
            <router-link to="galerija" class="button button-primary-outline button-ujarak button-size-1">Pogledaj cijelu galeriju</router-link>
        </div>
        
        <div v-bind:class="[modalIsActive ? 'in' : 'hidden']" class="lg-backdrop" style="transition-duration: 150ms;"></div>
        <div v-bind:class="[modalIsActive ? 'show-image' : 'hidden']" class="image-gallery-modal lg-outer lightGallery-in-carousel lg-css3 lg-use-transition-for-zoom lg-visible show-image">
          <div class="modal-gallery-navigation" v-bind:class="[images.length <= 1 ? 'hidden' : '']">
              <img src="./../../icons/arrow_left.png" alt="close icon" class="modal-navigation-arrow left" @click="sliderPrev()">
              <img src="./../../icons/arrow_right.png" alt="close icon" class="modal-navigation-arrow right" @click="sliderNext()">
          </div>
          <div v-touch:swipe="swipeHandler" class="lg" style="width:100%; height:100%">
            <div class="lg-inner" style="transition-timing-function: ease; transition-duration: 600ms;">
              <div class="lg-item lg-next-slide lg-prev-slide lg-loaded lg-current lg-complete lg-zoomable">
                <div class="lg-img-wrap">
                  <img class="lg-object lg-image" :src="getSrcLink(this.currentID)">
                </div>
              </div>
            </div>
            <div class="close-icon-container post-single">
              <img src="./../../icons/close_icon.png" alt="close icon" class="modal-close-icon" @click="closeModalWindow()">
            </div>         
          </div>
        </div>        
  </section>
</template>

<script>
import axios from 'axios';
export default {
   data(){
      return{
        componentLoaded: false,
        currentID: 0,        
        images:'',
        originalImagesList:'',
        modalIsActive: false,
      }  
   },
  methods:{
    fetchData(){
        axios({
          method: 'get',
          url: this.apiPath + 'gallery/getLastImages.php'
        })
        .then(function(response) {
          this.images = response.data;
          this.originalImagesList = this.images;
          this.componentLoaded = true;          
        }.bind(this))
        .catch((error) => {
          console.log(error);
         });             
    },
    showModalWindow(id){
      this.modalIsActive = true;
      this.currentID = id;
    },
    closeModalWindow(){
      this.modalIsActive = false;
      this.currentID = 0;
    },
    sliderNext(){
      this.currentID = this.currentID >= this.images.length-1 ? 0 : this.currentID + 1;
    },
    sliderPrev(){
      this.currentID = this.currentID <= 0 ? this.images.length-1 : this.currentID - 1;
    },
    swipeHandler (direction) {
      if(direction == "left"){
        this.sliderNext();
      }
      if(direction == "right"){
        this.sliderPrev();
      }
    }                                      
   },
   computed: {
      getSrcLink: function() {
        return function(id) {
          if(! this.componentLoaded)
            return null;
          return this.dataPath + 'photo_gallery/' + this.images[id].Image;
      }
    }
   },   
   created(){
    this.fetchData();
    window.addEventListener('keydown', function(e) {
      if(this.modalIsActive == true){
        if(e.code == "ArrowLeft")
          this.currentID = this.currentID <= 0 ? this.images.length-1 : this.currentID - 1;
        else if(e.code == "ArrowRight")
          this.currentID = this.currentID >= this.images.length-1 ? 0 : this.currentID + 1;
      }
    });       
   } 
}
</script>

<style lang="scss">
.about-us{   
    &.bg-gray-lighter {
        background-color: #f2f3f8;
    }
}

.image-item{
  cursor:pointer;
}

.shell-fluid{
      .range{
        .image-item{
          opacity: 0;

        }
      }
}

.hidden{
  display:none;
}

/****MODAL WINDOW*****/
.modal-gallery-navigation{
    width: 100%;
    position: absolute;
    z-index: 1161;
    bottom: 0;
    top: 0;
    margin: auto;
    height: 40px;

    .modal-navigation-arrow{
      height:40px;
      padding: .5rem;
      cursor: pointer;
      transition: box-shadow .3s;

      &:hover{
        opacity: .6;
      }

      &.left{
        float: left;
        margin-left: 8%;
      }
      &.right{
        float: right;
        margin-right: 8%;
      }
    }
}

.close-icon-container{
width: 100%;
    position: absolute;
    z-index: 1161;
    top: 0;
    right:0;
    text-align: right;
  .modal-close-icon{
    width: 18px;
    margin: 1rem;
    cursor: pointer;
    float: right;
    &:hover{
      opacity: .7;
    }
  }
}
/********************/

@media only screen and (max-width: 768px) {
  .photo_gallery{
    .shell-condensed{
      .range{
        padding: 0 1rem;
        .image-item{
          width: 47.5%;
          max-width: 47.5%;
          margin-bottom: 1rem;

          &:nth-child(odd){
            margin-right: 5%;    
          }

          a{
            .thumb-ruby__caption{
              min-height: 100px !important;
              width: 100px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/LastPhotos.vue